/**
 * Modelo para os dados de uma permissão de acesso
 */
class Permissao {

    /**
     * Cria uma nova instância de permissão
     * @param {Number} id Identificação única da permissão
     * @param {String} descricao Descrição da permissão
     * @param {String} identificador Identificador textual da permissão
     */
    constructor(id, descricao, identificador) {
        /** @member {Number} id Identificação única da permissão */
        this.id = id ?? null;
        /** @member {String} descricao Descrição da permissão */
        this.descricao = descricao ?? null;
        /** @member {String} identificador Identificador textual da permissão */
        this.identificador = identificador ?? null;
    }

    /**
     * Cria uma cópia do objeto original
     * @param {Permissao} permissao Objeto a ser clonado
     * @returns {Permissao} Retorna uma nova instância de Permissão com os dados do objeto clonado
     */
    static clone(permissao) {
        return new Permissao(permissao.id, permissao.descricao, permissao.identificador);
    }
}

export default Permissao;